import { x } from '@xstyled/styled-components';
import React from 'react';
import { MediaPlayerProvider } from '~/ui/video-player/MediaPlayerProvider';
import { AUDIO_POPUP } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { PopupButton } from './components/PopupButton';

interface Props {
  mediaUrl?: string;
  subtitlesUrl?: string;
  autoPlay?: boolean;
  name?: string;
  body?: string;
  empty?: boolean;
  top?: number;
  left?: number;
  pixelCoordinates?: string;
  shouldShow?: boolean;
  title?: number | string;

  /**
   * When true, the popup will prevent the next button from showing until the popup's
   * audio has been played. If there is no audio, opening the popup will unblock.
   */
  blocking?: boolean;
  replay?: boolean;
  isPopupCentered?: boolean;
  btnSize?: number;
  scroll?: boolean;
  parentId?: string;
  editable?: boolean;
}

export type AudioPopupDefinition = ItemDefinition<typeof AUDIO_POPUP, Props>;

function convertHTML(entity: string): string {
  //Please note that default function decodeHTML may not be available in all JavaScript environments, it is why i created new function for it
  const tempElement = document.createElement('div');
  tempElement.innerHTML = entity;
  return tempElement.textContent || '';
}

export class AudioPopup extends Item<typeof AUDIO_POPUP, Props> {
  protected render({
    mediaUrl,
    id,
    name,
    top,
    empty,
    left,
    shouldShow = true,
    blocking = false,
    subtitlesUrl,
    body,
    title,
    replay = false,
    isPopupCentered = false,
    btnSize,
    scroll = false,
    parentId,
    editable = true
  }: RenderProps<Props>) {
    return top && left ? (
      <x.div position="absolute" top={`${top}%`} left={`${left}%`}>
        <MediaPlayerProvider>
          <PopupButton
            mediaUrl={mediaUrl}
            subtitlesUrl={subtitlesUrl}
            id={id}
            shouldShow={shouldShow}
            name={name || ''}
            body={body || ''}
            blocking={blocking}
            replay={replay}
            title={title}
            isPopupCentered={isPopupCentered}
            btnSize={btnSize}
            scroll={scroll}
            parentId={parentId}
            editable={editable}
          />
        </MediaPlayerProvider>
      </x.div>
    ) : (
      <MediaPlayerProvider>
        <PopupButton
          mediaUrl={mediaUrl}
          id={id}
          name={name || ''}
          body={body || ''}
          shouldShow={shouldShow}
          blocking={blocking}
          replay={replay}
          subtitlesUrl={subtitlesUrl}
          title={title}
          isPopupCentered={isPopupCentered}
          btnSize={btnSize}
          scroll={scroll}
          parentId={parentId}
          editable={editable}
        />
      </MediaPlayerProvider>
    );
  }
}

registry[AUDIO_POPUP] = AudioPopup;
